import { memo } from "react";

const Check = () => (
  <svg width="32" height="32" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="13.5" stroke="#D5D5D5" />
    <g clipPath="url(#clip0_626_10057)">
      <path d="M24 7H4V21H24V7Z" fill="white" fillOpacity="0.01" />
      <path
        d="M5.6665 9.91634C5.6665 9.59417 6.0396 9.33301 6.49984 9.33301H21.4998C21.9601 9.33301 22.3332 9.59417 22.3332 9.91634V18.083C22.3332 18.4052 21.9601 18.6663 21.4998 18.6663H6.49984C6.0396 18.6663 5.6665 18.4052 5.6665 18.083V9.91634Z"
        stroke="#9F9F9F"
        strokeWidth="1.16667"
        strokeLinejoin="round"
      />
      <path
        d="M5.6665 11.667H22.3332"
        stroke="#9F9F9F"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15.25 16.333H19" stroke="#9F9F9F" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M22.3335 9.91699V14.5837"
        stroke="#9F9F9F"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.6665 9.91699V14.5837"
        stroke="#9F9F9F"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_626_10057">
        <rect width="20" height="14" fill="white" transform="translate(4 7)" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(Check);
